import { Component, h, Element, Method, Listen, State } from "@stencil/core";

@Component({
  tag: "nj-shopping-cart-dialog",
  styleUrl: "nj-shopping-cart-dialog.scss",
  shadow: true
})

export class NjShoppingCartDialog {
    shoppingCartPrice: number = 0.00

    @Element() el: HTMLElement;

    @State() isVisible: boolean = false;
    @State() prebookData: any = null

    @Listen('click', { target: 'window' })
	onBodyClick() {
		this.hide();
	}

    @Listen('shoppingCartBtnClicked', { target: 'window' })
	onshoppingCartBtnClick() {
		this.hide();
	}


    @Method()
    async toggle() {
        if (this.isVisible) {
            this.hide();
        } else {
            this.show();
        }
    }

    @Method()
	async show() {
		this.isVisible = true;
        this.isVisible = this.isVisible
	}

	@Method()
	async hide() {
		this.isVisible = false;
	}

    handleToggleClick(ev) {
        ev.preventDefault();
        ev.stopPropagation();
    }

    render()  {
        return(
            <div class={this.isVisible ? "shopping-cart-btn__content shopping-cart-btn__content--open" : "shopping-cart-btn__content"}>
                <nj-shopping-cart />
            </div>
        )
    }
}
